/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NewsletterComponentFromJSON, NewsletterComponentToJSON, } from './NewsletterComponent';
import { StrapiBlockFromJSON, StrapiBlockToJSON, } from './StrapiBlock';
import { ThemeListFromJSON, ThemeListToJSON, } from './ThemeList';
import { EmailConfigComponentFromJSON, EmailConfigComponentToJSON, } from './EmailConfigComponent';
import { StepComponentFromJSON, StepComponentToJSON, } from './StepComponent';
import { ContactComponentFromJSON, ContactComponentToJSON, } from './ContactComponent';
import { OnSubmitComponentFromJSON, OnSubmitComponentToJSON, } from './OnSubmitComponent';
import { NavigationComponentFromJSON, NavigationComponentToJSON, } from './NavigationComponent';
/**
 * Check if a given object implements the DynamicForm interface.
 */
export function instanceOfDynamicForm(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('documentId' in value) || value['documentId'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('publishedAt' in value) || value['publishedAt'] === undefined)
        return false;
    if (!('steps' in value) || value['steps'] === undefined)
        return false;
    if (!('onSubmit' in value) || value['onSubmit'] === undefined)
        return false;
    return true;
}
export function DynamicFormFromJSON(json) {
    return DynamicFormFromJSONTyped(json, false);
}
export function DynamicFormFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'documentId': json['documentId'],
        'title': json['title'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'publishedAt': (new Date(json['publishedAt'])),
        'intro': json['intro'] == null ? undefined : (json['intro'].map(StrapiBlockFromJSON)),
        'useContact': json['useContact'] == null ? undefined : json['useContact'],
        'contact': json['contact'] == null ? undefined : ContactComponentFromJSON(json['contact']),
        'steps': (json['steps'].map(StepComponentFromJSON)),
        'themes': json['themes'] == null ? undefined : ThemeListFromJSON(json['themes']),
        'useNewsletter': json['useNewsletter'] == null ? undefined : json['useNewsletter'],
        'newsletter': json['newsletter'] == null ? undefined : NewsletterComponentFromJSON(json['newsletter']),
        'onSubmit': OnSubmitComponentFromJSON(json['onSubmit']),
        'email': json['email'] == null ? undefined : EmailConfigComponentFromJSON(json['email']),
        'navigation': json['navigation'] == null ? undefined : NavigationComponentFromJSON(json['navigation']),
    };
}
export function DynamicFormToJSON(json) {
    return DynamicFormToJSONTyped(json, false);
}
export function DynamicFormToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'documentId': value['documentId'],
        'title': value['title'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'publishedAt': value['publishedAt'].toISOString(),
        'intro': value['intro'] == null ? undefined : (value['intro'].map(StrapiBlockToJSON)),
        'useContact': value['useContact'],
        'contact': ContactComponentToJSON(value['contact']),
        'steps': (value['steps'].map(StepComponentToJSON)),
        'themes': ThemeListToJSON(value['themes']),
        'useNewsletter': value['useNewsletter'],
        'newsletter': NewsletterComponentToJSON(value['newsletter']),
        'onSubmit': OnSubmitComponentToJSON(value['onSubmit']),
        'email': EmailConfigComponentToJSON(value['email']),
        'navigation': NavigationComponentToJSON(value['navigation']),
    };
}
